import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { contactRoutes } from '../../../routes';
import { ChannelItemDirection } from '../../../sic-lib/enums/ChannelItemDirection';
import { ChannelItemType } from '../../../sic-lib/enums/ChannelItemType';
import NavLinkListItem from '../../Navigation/NavLinkListItem/NavLinkListItem';
import DisplayPhoneNumber from '../../Shared/DisplayPhoneNumber/DisplayPhoneNumber';
import NewRecentChannelIcon from '../NewRecentChannelIcon/NewRecentChannelIcon';
import NewRecentItemCheckbox from '../NewRecentItemCheckbox/NewRecentItemCheckbox';

const useStyles = makeStyles()((theme: Theme) => ({
    root: {
        /* Important for height to be inforced because is a virtual list */
        height: '72px',
        overflow: 'hidden',
        borderBottom: `1px solid ${theme.palette.divider}`,
    },
    item: {
        height: 'inherit',
        paddingRight: '72px',
        paddingLeft: '72px',
        listStyle: 'none',
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
        },
    },
    primaryText: {
        color: theme.palette.text.primary,
    },
    checkbox: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        left: 0,
        zIndex: 100,
        padding: theme.spacing(0.5, 0),
    },
    action: {
        width: '72px',
        right: 0,
    },
}));

interface Props {
    contactName: string;
    contactId: number;
    textPreview: string;
    numUnread: number;
    channelType: ChannelItemType;
    direction: ChannelItemDirection;
    lastMessage: string;
}

export default function NewRecentItem({
    contactId,
    contactName,
    textPreview,
    numUnread,
    channelType,
    direction,
    lastMessage,
}: Props) {
    const { classes } = useStyles();
    const location = useLocation();
    const contactPath = contactRoutes.setDetails(contactId);

    const isSelected = React.useMemo(() => {
        return location.pathname.toLowerCase() === contactPath;
    }, [contactId, location]);

    return (
        <NavLinkListItem
            pathname={contactPath}
            selected={isSelected}
            ContainerProps={{
                className: classes.root,
            }}
            ContainerComponent="div"
            className={classes.item}
        >
            <ListItemIcon className={classes.checkbox}>
                <NewRecentItemCheckbox
                    contactId={contactId}
                    contactName={contactName}
                    numUnread={isSelected ? 0 : numUnread}
                />
            </ListItemIcon>
            <ListItemText
                primary={contactName}
                primaryTypographyProps={{
                    noWrap: true,
                    className: classes.primaryText,
                }}
                secondary={
                    channelType === ChannelItemType.call ? (
                        <DisplayPhoneNumber phoneNumber={textPreview} />
                    ) : (
                        textPreview
                    )
                }
                secondaryTypographyProps={{
                    noWrap: true,
                }}
            />
            <ListItemSecondaryAction className={classes.action}>
                <NewRecentChannelIcon
                    channelType={channelType}
                    direction={direction}
                    lastMessage={lastMessage}
                />
            </ListItemSecondaryAction>
        </NavLinkListItem>
    );
}
